import { cn } from "@/lib/utils"
import * as React from "react"

const Textarea = React.forwardRef<
	HTMLTextAreaElement,
	React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
	return (
		<textarea
			className={cn(
				"border-input df-textarea df-input-base flex min-h-[120px] w-full resize-y rounded-md border px-4 py-3 text-xs transition-all duration-200",
				"placeholder:text-fieldPlaceholder",
				"focus-visible:border-ring focus-visible:shadow-[0_0_0_3px_hsl(var(--ring)/0.12)] focus-visible:outline-none",
				"focus:df-input-focus",
				"disabled:cursor-not-allowed disabled:opacity-50",
				"md:text-sm",
				className,
			)}
			ref={ref}
			{...props}
		/>
	)
})
Textarea.displayName = "Textarea"

export { Textarea }
